import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import Paper from '@material-ui/core/Paper';

import Divider from '@material-ui/core/Divider';
import MaterialTable from 'material-table';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import Button from '@material-ui/core/Button';
import PrintIcon from '@material-ui/icons/Print';

import XLSX from 'xlsx';

import * as OrdersManagerClient from '../clients/OrdersManager';
const styles = (theme) => ({
    root: {
        padding: 40,
        position: 'relative',
    },
    paper: {
        padding: theme.spacing(2),
        // color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2),
        fontSize: '1rem',
        color: '#000000DE',
    },
    button: {
        margin: theme.spacing(1),
        marginBottom: '2rem',
    },
});

class OrderDetailInternal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: undefined,
        };
    }

    componentDidMount() {
        OrdersManagerClient.get(this.props.id).then((data) => {
            this.setState({ data });
        });
    }

    render() {
        if (this.state.data === undefined) return <div />;

        return (
            <div>
                <div className="order-detail" style={{ padding: '2rem' }} ref={(el) => (this.componentRef = el)}>
                    <Paper className={this.props.classes.paper}>
                        <table style={{ width: '100%', textAlign: 'left', verticalAlign: 'top' }}>
                            <tbody>
                                <tr>
                                    <td>
                                        <strong>Número de pedido</strong>: {this.state.data.id}
                                        <br />
                                        <span style={{ color: this.state.data.deliveryTime !== undefined ? 'blue' : 'green' }}>
                                            {this.state.data.deliveryTime ? 'Recogida en tienda' : 'Entrega a domicílio'}
                                        </span>
                                    </td>
                                    <td>
                                        <strong>Fecha Entrega</strong>: {new Date(this.state.data.deliveryDate).toLocaleDateString()}
                                        {this.state.data.deliveryTime !== undefined && (
                                            <>
                                                <br />
                                                <strong>Hora Entrega</strong>: {this.state.data.deliveryTime}
                                            </>
                                        )}
                                    </td>
                                    <td>
                                        <strong>Fecha Creación</strong>: {new Date(this.state.data.dateCreated).toLocaleDateString()}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <br />
                                        <Divider />
                                        <br />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>Nombre y Apellidos</strong>: {this.state.data.customer.name} {this.state.data.customer.surname ? this.state.data.customer.surname : ''}{' '}
                                        {this.state.data.customer.surname2 ? this.state.data.customer.surname2 : ''}
                                    </td>
                                    <td>
                                        <strong>Tarjeta fidelización</strong>: {this.state.data.customer.loyaltyCode}
                                    </td>

                                    <td>
                                        <strong>DNI/NIE/Pasaporte</strong>: {this.state.data.customer.identifier}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>Teléfono</strong>: {this.state.data.customer.phone}
                                    </td>
                                    <td>
                                        <strong>e-Mail</strong>: {this.state.data.customer.email}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <strong>Dirección</strong>: {this.state.data.customer.address}, {this.state.data.customer.postalCode} {this.state.data.customer.city}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Paper>
                    <MaterialTable
                        title="Productos"
                        columns={[
                            {
                                field: 'product.category',
                                title: 'Categoría',
                                editable: 'never',
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                            },
                            {
                                field: 'product.id',
                                title: 'Id',
                                editable: 'never',
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                            },
                            {
                                field: 'product.name',
                                title: 'Nombre',
                                editable: 'never',
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                            },
                            {
                                field: 'product.format',
                                title: 'Formato',
                                editable: 'never',
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                            },
                            {
                                field: 'product.cut',
                                title: 'Corte',
                                editable: 'never',
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                            },
                            {
                                field: 'product.priceKg',
                                title: 'Precio Kg',
                                editable: 'never',
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                                render: (rowData) => <span>{rowData['product']['priceKg'] ? rowData['product']['priceKg'].toLocaleString() : ''}</span>,
                            },
                            {
                                field: 'product.price',
                                title: 'Precio',
                                editable: 'never',
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                                render: (rowData) => <span>{rowData['product']['price'] ? rowData['product']['price'].toLocaleString() : ''}</span>,
                            },
                            {
                                field: 'quantity',
                                title: 'Cantidad',
                                editable: 'never',
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                                render: (rowData) => <span>{rowData['quantity'] ? rowData['quantity'].toLocaleString() : ''}</span>,
                            },
                            {
                                field: 'amount',
                                title: 'Importe',
                                editable: 'never',
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                                render: (rowData) => (
                                    <span>
                                        <strong>{rowData['amount'] ? rowData['amount'].toLocaleString() : ''} €</strong>
                                    </span>
                                ),
                            },
                        ]}
                        data={this.state.data.lines}
                        options={{
                            toolbar: false,
                            search: false,
                            pageSize: this.state.data.lines.length,
                            actionsColumnIndex: -1,
                        }}
                        localization={{
                            pagination: {
                                labelDisplayedRows: '{from}-{to} de {count}',
                            },
                            toolbar: {
                                nRowsSelected: '{0} filas(s) seleccionadas',
                                searchTooltip: 'Buscar',
                                searchPlaceholder: 'Buscar',
                            },
                            header: {
                                actions: '',
                            },
                            body: {
                                emptyDataSourceMessage: 'No hay datos a mostrar',
                                filterRow: {
                                    filterTooltip: 'Filtro',
                                },
                            },
                        }}
                    />
                    <br />
                    <Paper className={this.props.classes.paper} style={{ textAlign: 'right' }}>
                        TOTAL: <strong>{Number.parseFloat(this.state.data.amount.toFixed(2)).toLocaleString()} €</strong>
                    </Paper>
                </div>
                <ReactToPrint content={() => this.componentRef}>
                    <PrintContextConsumer>
                        {({ handlePrint }) => (
                            <Button variant="contained" color="primary" className={this.props.classes.button} onClick={handlePrint} startIcon={<PrintIcon />}>
                                Imprimir
                            </Button>
                        )}
                    </PrintContextConsumer>
                </ReactToPrint>
            </div>
        );
    }
}
const OrderDetail = withStyles(styles)(OrderDetailInternal);

class OrdersManager extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            alertOpen: false,
            alertMessage: '',
            alertSeverity: 'success',
            loading: true,
            columns: [
                {
                    field: 'id',
                    title: 'Id',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                },
                {
                    field: 'dateCreated',
                    title: 'Fecha Creación',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                    render: (rowData) => <span>{new Date(rowData['dateCreated']).toLocaleDateString()}</span>,
                },
                {
                    field: 'deliveryDate',
                    title: 'Fecha Entrega',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                    render: (rowData) => <span>{new Date(rowData['deliveryDate']).toLocaleDateString()}</span>,
                },
                {
                    field: 'deliveryTime',
                    title: 'Hora de Entrega',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                },
                {
                    field: 'customer',
                    title: 'Cliente',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                    render: (rowData) => (
                        <span>
                            {rowData['customer']['name']} {rowData['customer']['surname']} {rowData['customer']['surname2']}
                        </span>
                    ),
                },
                {
                    field: 'amount',
                    title: 'Importe',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                    render: (rowData) => <span>{Number.parseFloat(rowData['amount'].toFixed(2)).toLocaleString()} €</span>,
                },
                {
                    field: 'verifiedByRemote',
                    title: 'Impresa',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                    render: (rowData) => <span style={{ color: rowData['verifiedByRemote'] === true ? 'black' : 'red' }}>{rowData['verifiedByRemote'] === true ? 'Sí' : 'No'}</span>,
                },
                {
                    field: 'orderType',
                    title: 'Tipo de pedido',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                    render: (rowData) => <span style={{ color: rowData['deliveryTime'] !== undefined ? 'blue' : 'green' }}>{rowData['orderType']}</span>,
                },
            ],
        };
    }
    showMessage = (alertMessage, alertSeverity) => {
        this.setState({ alertMessage, alertSeverity, alertOpen: true });
    };

    handleClose = () => {
        this.setState({ alertOpen: false });
    };

    handleDownload = async () => {
        var wb = XLSX.utils.book_new();
        wb.Props = {
            Title: 'Comandes',
            CreatedDate: new Date(),
        };
        const orders = await OrdersManagerClient.getAllOrdersForExport();
        const columns = ['Id', 'Data creació', 'Data entrega', 'Hora entrega', 'Client', 'Import', 'Verificada', 'Tipus'];

        let columnsKeys = ['id', 'dateCreated', 'deliveryDate', 'deliveryTime', 'customer', 'amount', 'verifiedByRemote', 'orderType'];

        let ordersRow = [columns];

        ordersRow = ordersRow.concat(
            orders.map((order) => {
                let arrayOrder = [];
                for (let k of columnsKeys) {
                    if (k === 'customer') {
                        arrayOrder.push(`${order[k].name} ${order[k].surname} ${order[k].surname2}`);
                    } else {
                        arrayOrder.push(order[k]);
                    }
                }
                return arrayOrder;
            })
        );

        //  {
        //      rowData['customer']['name'];
        //  }
        //  {
        //      rowData['customer']['surname'];
        //  }
        //  {
        //      rowData['customer']['surname2'];
        //  }

        wb.SheetNames.push('Comandes');
        var ws = XLSX.utils.aoa_to_sheet(ordersRow);
        wb.Sheets['Comandes'] = ws;
        XLSX.writeFile(wb, 'Comandes.xlsx');
    };

    refreshOrdersList = () => {
        OrdersManagerClient.invalidateCache();
        this.tableRef.current && this.tableRef.current.onQueryChange();
        OrdersManagerClient.getAll().then((data) => this.setState({ data }));
    };

    render() {
        return (
            <div className={this.props.classes.root}>
                <Snackbar autoHideDuration={6000} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.alertOpen} onClose={this.handleClose}>
                    <MuiAlert elevation={6} variant="filled" severity={this.state.alertSeverity} onClose={this.handleClose}>
                        {this.state.alertMessage}
                    </MuiAlert>
                </Snackbar>
                <MaterialTable
                    title="Pedidos"
                    tableRef={this.tableRef}
                    style={{ minHeight: 'calc(100vh - 160px)' }}
                    columns={this.state.columns}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            OrdersManagerClient.getAll(query.page + 1, query.pageSize, query.search).then((result) => {
                                // OrdersManagerClient.getSummary().then((data) => {
                                //     console.log(data);
                                //     for (let c of summary) {
                                //         console.log(`${c.customer.loyaltyCode ? c.customer.loyaltyCode : 'Sense tarja'}\t${c.customer.name} ${c.customer.surname} ${c.customer.surname2}\t${c.amount}\t${c.numOrders}`);
                                //     }
                                // });
                                resolve({
                                    data: result.data,
                                    page: result.page - 1,
                                    totalCount: result.total,
                                });
                            });
                        })
                    }
                    options={{
                        search: true,
                        pageSize: 20,
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportCsv: this.handleDownload,
                    }}
                    localization={{
                        pagination: {
                            labelDisplayedRows: '{from}-{to} de {count}',
                        },
                        toolbar: {
                            nRowsSelected: '{0} filas(s) seleccionadas',
                            searchTooltip: 'Buscar',
                            searchPlaceholder: 'Buscar',
                            exportName: 'Exportar',
                        },
                        header: {
                            actions: '',
                        },
                        body: {
                            emptyDataSourceMessage: 'No hay datos a mostrar',
                            filterRow: {
                                filterTooltip: 'Filtro',
                            },
                        },
                    }}
                    detailPanel={[
                        {
                            tooltip: 'Mostrar pedido',
                            render: (rowData) => {
                                return (
                                    <div
                                        style={{
                                            // fontSize: 100,
                                            textAlign: 'center',
                                            color: 'white',
                                        }}
                                    >
                                        <OrderDetail onShowMessage={this.showMessage} id={rowData['id']} />
                                    </div>
                                );
                            },
                        },
                    ]}
                    actions={[
                        // (rowData) => ({
                        //     icon: () => (rowData.Enabled === true ? <LockOpenIcon /> : <LockIcon />),
                        //     tooltip: rowData.Enabled === true ? 'Disable user' : 'Enable user',
                        //     onClick: () => (rowData.Enabled === true ? this.disableUser(rowData['Username']) : this.enableUser(rowData['Username'])),
                        // }),
                        // (rowData) => ({
                        //     icon: () => <PersonAddIcon />,
                        //     tooltip: 'Confirm user',
                        //     onClick: () => this.confirmUser(rowData['Username']),
                        //     disabled: rowData['UserStatus'] !== 'UNCONFIRMED',
                        // }),
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => this.refreshOrdersList(),
                        },
                    ]}
                />
            </div>
        );
    }
}

export default withStyles(styles)(OrdersManager);
